export default "__VITE_ASSET__0a2ce2c9__"